
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"81","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.5 57.375c.956 0 1.758-.324 2.406-.972.646-.646.969-1.447.969-2.403s-.323-1.758-.969-2.406c-.648-.646-1.45-.969-2.406-.969-.956 0-1.757.323-2.403.969-.648.648-.972 1.45-.972 2.406 0 .956.324 1.757.972 2.403.646.648 1.447.972 2.403.972zm0 16.875c-4.669 0-9.056-.886-13.163-2.66-4.106-1.77-7.678-4.174-10.715-7.212-3.038-3.037-5.442-6.61-7.213-10.715C7.636 49.556 6.75 45.169 6.75 40.5c0-4.669.886-9.056 2.66-13.163 1.77-4.106 4.174-7.678 7.212-10.715 3.037-3.038 6.61-5.443 10.715-7.216C31.444 7.636 35.831 6.75 40.5 6.75c4.669 0 9.056.885 13.163 2.656 4.106 1.773 7.678 4.178 10.715 7.216 3.038 3.037 5.442 6.61 7.213 10.715 1.773 4.107 2.659 8.494 2.659 13.163 0 4.669-.886 9.056-2.66 13.163-1.77 4.106-4.174 7.678-7.212 10.715-3.037 3.038-6.61 5.442-10.715 7.213-4.107 1.773-8.494 2.659-13.163 2.659zm0-30.375c.956 0 1.758-.324 2.406-.972.646-.646.969-1.447.969-2.403V27c0-.956-.323-1.758-.969-2.406-.648-.646-1.45-.969-2.406-.969-.956 0-1.757.323-2.403.969-.648.648-.972 1.45-.972 2.406v13.5c0 .956.324 1.757.972 2.403.646.648 1.447.972 2.403.972z","fill":"#FF9595"}})])
          )
        }
      }
    